import React from 'react';
import TestCard from './TestCard';
import '../css/estaSemana.css';

const TabContentEstaSemana = ({ testsDestacados, temaActual, onDescargarTest }) => {
  return (
    <div className="tab-content esta-semana-content">
      <div className="tema-header-card">
        <h3>TEST REPASO TEMA {temaActual}</h3>
        <div className="tema-info">
          <p>Tema actual de estudio: <span>Tema {temaActual}</span></p>
        </div>
      </div>
      
      {testsDestacados.length > 0 ? (
        <div className="tests-grid">
          {testsDestacados.map((test, index) => (
            <TestCard 
              key={index} 
              test={test} 
              destacado={true} 
              onDescargar={onDescargarTest} 
            />
          ))}
        </div>
      ) : (
        <div className="no-tests-panel">
          <div className="no-tests-icon">
            <i className="fas fa-clipboard-list"></i>
          </div>
          <p className="no-tests-message">
            No hay tests destacados para esta semana
          </p>
          <p className="no-tests-info">
            Los tests destacados se asignan automáticamente al tema de la semana actual.
            Cada mes se agregan 4 tests de repaso que se distribuyen en los 6 temas de la vuelta al temario.
          </p>
          <div className="no-tests-action">
            <p className="no-tests-suggestion">
              <i className="fas fa-arrow-circle-right"></i> Mientras tanto, puedes revisar los tests disponibles en la pestaña "Todos los tests".
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TabContentEstaSemana;